<div class="flex gap-4">
    <!-- Bar Chart -->
    <div class="flex-1">
      <div class="card pt-3 pl-2">
        <div class="flex justify-content-between mb-3">
          <!-- Left side with title and view buttons -->
          <div class="flex gap-2 align-items-center">
            <h3 class="text-lg m-0">Order Count</h3>
            <div class="flex gap-2 ml-3">
              <button pButton label="Week" [class.p-button-outlined]="view !== 'weekly'"
                (click)="changeView('weekly')" class="p-button-sm">
              </button>
              <button pButton label="Month" [class.p-button-outlined]="view !== 'monthly'"
                (click)="changeView('monthly')" class="p-button-sm">
              </button>
            </div>
          </div>
          <!-- Right side with dropdowns -->
          <div class="flex gap-2 align-items-center">
            <p-dropdown *ngIf="view === 'weekly'" [options]="months" [(ngModel)]="selectedMonth"
              optionLabel="name" optionValue="value" (onChange)="loadData()" [style]="{'width':'150px'}"
              placeholder="Select Month">
            </p-dropdown>
            <p-dropdown [options]="years" [(ngModel)]="selectedYear" (onChange)="loadData()"
              [style]="{'width':'150px'}" placeholder="Select Year">
            </p-dropdown>
          </div>
        </div>
        <div *ngIf="!hasData" class="flex flex-column align-items-center justify-content-center" style="height: 180px">
          <i class="pi pi-chart-bar text-4xl text-500 mb-3"></i>
          <span class="text-500">No data available for {{ getSelectedPeriodText() }}</span>
        </div>
        <p-chart *ngIf="hasData" type="bar" [data]="barChartData" [options]="barChartOptions" height="180px">
        </p-chart>
      </div>
    </div>
  
    <!-- Performance Charts -->
    <div class="flex-1">
      <div class="card pt-3 pr-2">
        <h3 class="mb-3 text-lg text-center">Performance Metrics</h3>
        <div class="flex gap-2">
          <!-- Pickup Chart -->
          <div class="flex-1">
            <p-chart 
              type="pie" 
              [data]="pickupChartData" 
              [options]="pickupChartOptions"
              height="180px">
            </p-chart>
          </div>
          <!-- Delivery Chart -->
          <div class="flex-1">
            <p-chart 
              type="pie" 
              [data]="deliveryChartData" 
              [options]="deliveryChartOptions"
              height="180px">
            </p-chart>
          </div>
        </div>
      </div>
    </div>
  </div>